import * as React from "react";
import { GUIDE_HIGHLIGHT_COLOR } from "./guideIndicator";

export const guidePopupStyle: React.CSSProperties = {
  backgroundColor: "var(--color-drop)",
  border: `2px solid ${GUIDE_HIGHLIGHT_COLOR}`,
  borderRadius: 8,
  padding: "16px",
  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
  maxWidth: 350,
};

export const highlightTextStyle: React.CSSProperties = {
  color: GUIDE_HIGHLIGHT_COLOR,
  fontWeight: 600,
};

export const guideHeaderStyle: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: 16,
};

export const guideProgressStyle: React.CSSProperties = {
  fontSize: 12,
  color: "var(--color-label-secondary)",
};

export const guideSkipStyle: React.CSSProperties = {
  fontSize: 12,
  color: "var(--color-label-secondary)",
  cursor: "pointer",
  textDecoration: "underline",
};
